export class Basic {
    value: any;
    name: string;

    public constructor(init?: Partial<Basic>) {
        Object.assign(this, init);
    }
}
